import { createSlice } from '@reduxjs/toolkit';
import { pick } from 'ramda';

import { NAMESPACE } from './constants';

const initialState = () => ({
  showNodePanel: false,
  content: null,
  uploadingFile: false,
});

// Estado del editor visual: panel de propiedades del nodo abierto y subida de archivos.
const visualBuilderSlice = createSlice({
  name: NAMESPACE,
  initialState,
  reducers: {
    toggleElementInfo: (state, { payload }) => {
      Object.assign(state, pick(['showNodePanel', 'content'], payload));
    },
    uploadingFileToS3: (state, { payload }) => { state.uploadingFile = payload.uploading; },
    resetVisualbuilder: () => initialState(),
  },
});

export const visualBuilderActions = visualBuilderSlice.actions;

export default { [NAMESPACE]: visualBuilderSlice.reducer };
